import { render, staticRenderFns } from "./dictionaryManagement.vue?vue&type=template&id=426a5b0a&scoped=true&"
import script from "./dictionaryManagement.vue?vue&type=script&lang=js&"
export * from "./dictionaryManagement.vue?vue&type=script&lang=js&"
import style0 from "./dictionaryManagement.vue?vue&type=style&index=0&id=426a5b0a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426a5b0a",
  null
  
)

export default component.exports